import Grid from '@mui/material/Grid';
import TextField from 'src/common/components/TextField';

type Props = {
  code: string;
};

function PersonalDetails({ code }: Props) {
  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <TextField label="Name" />
      </Grid>
      <Grid item xs={12}>
        <TextField label="Age" />
      </Grid>
      <Grid item xs={12}>
        <TextField label="Something" />
      </Grid>
    </Grid>
  );
}

export default PersonalDetails;
